import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  locationList: [], 
  formData: {
    employee_nik: '',
    employee_name: '',
    employee_status: '',
    divisi_id: '',
    jabatan_id: '',
    employee_joindate: '',
    employee_createdby: '',
    employee_createddate: '',
    employee_modifyby: '',
    employee_modifydate: '',
    rowid: '',
    employee_contractperiode_start: '',
    employee_contractperiode_end: '',
    employee_nosio: '',
    employee_bpjsnaker_no: '',
    employee_bpjskes_no: '',
    employee_bpjskes_nama: '',
    employee_aum_no: '',
    employee_aum_nama: '',
    employee_bankaccount_bank: '',
    employee_bankaccount_norek: '',
    employee_ktpno: '',
    employee_alamat: '',
    employee_dob: '',
    employee_jumlahtanggungan: '',
    employee_bpjsnaker_nama: '',
    employee_appsrole: '',
    employee_username: '',
    employee_password: '',
    employee_isresign: '',
    employee_resignreason: '',
    work_location: '',
    employee_code: ''
  },
   // Menyimpan data yang diambil
  dataList: [],  // Menyimpan list data untuk persistence
  totalData: 0,  // Menyimpan total count untuk persistence
  loading: false,  // Menyimpan status loading
  error: null,  // Menyimpan pesan error jika ada
  loadingMessage: '',
  locationList: [],
  activeTab: 0,  // Menyimpan tab yang aktif (0 untuk List, 1 untuk Data)
};

const mst07employeeSlice = createSlice({
  name: 'mst07employee',  // Nama slice yang sesuai
  initialState,
  reducers: {
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    clearFormData: (state) => {
      state.formData = initialState.formData;  // Mengatur ulang formData ke nilai awal
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.error = action.payload;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: (state) => {
      return initialState;  // Mengatur ulang semua state ke nilai awal
    },
    setLocationList: (state, action) => {
      state.locationList = action.payload;
    },
    setActiveTab: (state, action) => {
      console.log('🔄 Redux setActiveTab called with:', action.payload, '(hrd07employee)');
      state.activeTab = action.payload;
    },
    setDataList: (state, action) => {
      state.dataList = action.payload;
    },
    setTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    clearModuleState: (state) => {
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.activeTab = 0;
      state.formData = initialState.formData;
    }
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  resetState,
  updateFormData,
  setLocationList,
  setActiveTab,
  setDataList,
  setTotalData,
  clearModuleState
} = mst07employeeSlice.actions;

export default mst07employeeSlice.reducer;
